import { Controller } from "@hotwired/stimulus"
import '@popperjs/core';
import { TempusDominus, Namespace } from '@eonasdan/tempus-dominus/dist/js/tempus-dominus';
import '@eonasdan/tempus-dominus/dist/css/tempus-dominus';
const datepickerConfig = {
  display: {
    components: {
      decades: false,
      year: true,
      month: true,
      date: true,
      hours: false,
      minutes: false,
      seconds: false,
    }
  },
  localization: {
    locale: 'es'
  }
}

// Connects to data-controller="datepicker"
export default class extends Controller {
  static values = {
    readonly: Boolean
  }

  connect() {
    const td = new TempusDominus(this.element, datepickerConfig)
    if (this.readonlyValue) td.disable();
  }
}
